import { createReducer, on } from '@ngrx/store';
import { PhotoGallery } from '@models/photo-gallery.model';
import {
  cannotCreatePhotoGallery,
  cannotFetchPhotoGalleries,
  cannotUpdatePhotoGallery,
  createPhotoGallery,
  deletePhotoGallery,
  fetchPhotoGalleries,
  photoGalleriesFetched,
  photoGalleryCreated,
  photoGalleryDeleted,
  photoGalleryUpdated,
  updatePhotoGallery
} from '../actions/photo-gallery.actions';
import { SharedState } from './index';

export interface PhotoGalleryState extends SharedState {
  galleries: PhotoGallery[];
}

export const initialPhotoGalleryState: PhotoGalleryState = {
  loaded: false,
  isLoading: false,
  error: '',
  galleries: [],
}

export const photoGalleryReducer = createReducer(
  initialPhotoGalleryState,
  on(fetchPhotoGalleries, (state) => ({...state, isLoading: true, error: '', loaded: false})),
  on(photoGalleriesFetched, (state, {payload}) => ({
    ...state,
    isLoading: false,
    loaded: true,
    error: '',
    galleries: payload
  })),
  on(cannotFetchPhotoGalleries, (state, {error}) => ({
    ...state,
    isLoading: false,
    loaded: false,
    error,
    galleries: []
  })),
  on(updatePhotoGallery, (state) => ({...state, isLoading: true, error: '', loaded: false})),
  on(photoGalleryUpdated, (state, {payload}) => ({
    ...state,
    isLoading: false,
    loaded: true,
    error: '',
    galleries: state.galleries.map(g => g.id === payload.id ? payload : g)
  })),
  on(cannotUpdatePhotoGallery, (state, {error}) => ({...state, isLoading: false, loaded: false, error})),
  on(createPhotoGallery, (state) => ({...state, isLoading: true, error: '', loaded: false})),
  on(photoGalleryCreated, (state, {payload}) => ({
    ...state,
    isLoading: false,
    loaded: true,
    error: '',
    galleries: [...state.galleries, payload]
  })),
  on(cannotCreatePhotoGallery, (state, {error}) => ({...state, isLoading: false, loaded: false, error})),
  on(deletePhotoGallery, (state) => ({...state, isLoading: true, error: '', loaded: false})),
  on(photoGalleryDeleted, (state, {payload}) => ({
    ...state,
    isLoading: false,
    loaded: true,
    error: '',
    galleries: state.galleries.filter(gallery => gallery.id !== payload)
  })),
  on(cannotCreatePhotoGallery, (state, {error}) => ({...state, isLoading: false, loaded: false, error})),
);
